// import momentJalali from "jalali-moment";
import { Product } from "../models/home-rows";
import { PurchaseType } from "../modules/subscription/models/subscribe-packages";

export function _(input: string | number | null | undefined) {
  if (!input === undefined) return "";
  if (!input === null) return "";
  const inputString = String(input);
  type NumberStrings =
    | "0"
    | "1"
    | "2"
    | "3"
    | "4"
    | "5"
    | "6"
    | "7"
    | "8"
    | "9";
  const mapObject = {
    "1": "۱",
    "2": "۲",
    "3": "۳",
    "4": "۴",
    "5": "۵",
    "6": "۶",
    "7": "۷",
    "8": "۸",
    "9": "۹",
    "0": "۰"
  };
  const answer = inputString.replace(
    /1|2|3|4|5|6|7|8|9|0/g,
    match => mapObject[match as NumberStrings]
  );
  return answer;
}

export function _r(input: string) {
  type NumberStrings =
    | "۱"
    | "۲"
    | "۳"
    | "۴"
    | "۵"
    | "۶"
    | "۷"
    | "۸"
    | "۹"
    | "۰";
  const mapObject = {
    "۱": "1",
    "۲": "2",
    "۳": "3",
    "۴": "4",
    "۵": "5",
    "۶": "6",
    "۷": "7",
    "۸": "8",
    "۹": "9",
    "۰": "0"
  };

  return input.replace(
    /۰|۱|۲|۳|۴|۵|۶|۷|۸|۹/g,
    match => mapObject[match as NumberStrings]
  );
}

export function isValidPhoneNumber(phone: string): boolean {
  const regex = new RegExp(/^(9|09|00989|\+989|989|0989)[01234]\d{8}$/, "i");
  const regex2 = new RegExp(/^(99|099|009899|\+9899|9899|09899)\d{8}$/, "i");
  return regex.test(_r(phone)) || regex2.test(_r(phone));
}

export const isValidEmail = (email: string) => {
  return !!String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export function isNumeric(str: any) {
  //if (typeof str != "string") return false // we only process strings!
  return (
    !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str))
  ); // ...and ensure strings of whitespace fail
}

export function uniqueFilter<T>(value: T, index: number, self: T[]) {
  return self.indexOf(value) === index;
}

export const isCollectionProduct = (product: Product) =>
  product.product_type === 3;

/**
 * Format bytes as human-readable text.
 *
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 * @param persian Persian or English letters.
 *
 * @return Formatted string.
 */
export function humanFileSize(bytes: number, si = false, dp = 1, persian = false) {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }
  const persianUnits = {
    kB: "کیلوبایت",
    MB: "مگابایت",
    GB: "گیگابایت",
    TB: "ترابایت",
  }
  const siUnits = ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const nonSiUnits = ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  const units = si
    ? siUnits
    : nonSiUnits;
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  );
  const shownUnit = persian ? persianUnits[siUnits[u]] : units[u];
  return bytes.toFixed(dp) + " " + shownUnit;
}

export function splitSeconds(secs: number) {
  // get total seconds between the times
  let delta = Math.abs(secs);

  // calculate (and subtract) whole days
  const days = Math.floor(delta / 86400);
  delta -= days * 86400;

  // calculate (and subtract) whole hours
  const hours = Math.floor(delta / 3600) % 24;
  delta -= hours * 3600;

  // calculate (and subtract) whole minutes
  const minutes = Math.floor(delta / 60) % 60;
  delta -= minutes * 60;

  // what's left is seconds
  const seconds = delta % 60;

  return { days, hours, minutes, seconds };
}

export function humanReadableTimeDiff(secs: number) {
  const { days, hours, minutes, seconds } = splitSeconds(secs);
  if (days > 0) return `${days} days and  ${hours} hours`;
  if (hours > 0) return `${hours} hours and  ${minutes} minutes`;
  if (minutes > 0) return `${minutes} minutes and  ${seconds} seconds`;

  return `${seconds} seconds`;
}

export function ellipsis(
  text: string,
  limitLength: number,
  wholeWords = false
) {
  if (text.length < limitLength) {
    return text;
  }
  const initial = text.substring(0, limitLength);
  return wholeWords ? initial.replace(/\s+\w+$/, "") + "..." : initial + "...";
}

export const _c = (
  styles: { readonly [key: string]: string },
  classes: string
) => {
  const splited = classes.split(/\s+/);
  let result = "";
  for (let i = 0; i < splited.length; i++) {
    const curr = splited[i];
    result += (i > 0 ? " " : "") + (styles[curr] ?? curr);
  }

  return result;
};

export const toKillo = (value: number = 1) => {
  if (value >= 1000000) {
    // For values greater than or equal to 1 million, round to millions
    const transformedNumber = (value / 1000000).toFixed(1);
    if (transformedNumber.endsWith(".0")) {
      return transformedNumber.slice(0, -2) + "M";
    }
    return transformedNumber + "M";
  } else if (value >= 1000) {
    // For values greater than or equal to 1 thousand, round to thousands
    const transformedNumber = (value / 1000).toFixed(1);
    if (transformedNumber.endsWith(".0")) {
      return transformedNumber.slice(0, -2) + "K";
    }
    return transformedNumber + "K";
  } else {
    // For values less than 1 thousand, return the original number
    return value.toString();
  }
};

export const toMinute = (value: number, hasSeconds: boolean) => {
  const seconds = value % 60;
  const minutes = (value / 60).toFixed();

  let transformedValue = +minutes ? minutes + " دقیقه" : "";
  if (hasSeconds && +minutes) transformedValue += " و ";
  if (hasSeconds) transformedValue += `${seconds} ثانیه`;
  return transformedValue;
};

export const commaSeprator = (value: string | number) => {
  return _(Number(value).toLocaleString());
};

export const reverseText = (text: string) => text.split("").reverse().join;

export const replaceUnderscore = (
  value: string,
  regexValue: string,
  replaceValue: string
) => {
  let regex = new RegExp(regexValue, "g");

  return value
    .replace(regex, replaceValue)
    .replace("---", "-")
    .replace(
      /\||\/|{|}|\|\^|\?|\*|[|]|\+|`|;|:|@|=|\$|,|\.|<|>|"|#|&|%|~|!|\(|\)|"|\\|`|;|'/g,
      ""
    )
    .replace("--", "-");
};

export const isSecret = (secret: string) => secret === "989127777777";

export const lastNumberPart = (input: string | null | undefined) =>
  input ? +input.split("-").reverse()[0] : 0;

export const purchaseTypeText = (purchaseType: number) => {
  switch (true) {
    case purchaseType == PurchaseType.CHARKHUNE_CODE:
      return " خرید از چارخونه";
    case purchaseType == PurchaseType.BAZAR_CODE:
      return " خرید از بازار";
    case purchaseType == PurchaseType.MYKET_CODE:
      return " خرید از مایکت";
    case purchaseType == PurchaseType.SADAD_CODE ||
      purchaseType == PurchaseType.SHAPARAK_CODE:
      return " خرید بانکی";
    case purchaseType == PurchaseType.GIFT_CODE:
      return "کد هدیه ";
    case purchaseType == PurchaseType.RESELLER_CODE:
      return " Reseller";
    case purchaseType == PurchaseType.FREE_PACKAGE_CODE:
      return " اشتراک رایگان";
    case purchaseType == PurchaseType.VANDAR_CODE:
      return "خرید وندار (تمدید خودکار)";
    default:
  }
};

export const toToman = (rial: number) => {
  return rial / 10;
};

export const nicknameLimited = (nickname: string) =>
  nickname.slice(0, 16) + (nickname.length > 16 ? "..." : "");
